












import Vue from 'vue';
import { User, ListElement } from '../types';
import InviteUserBtn from './invite/InviteUserBtn.vue';
import UsersList from './UsersList.vue';

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Users',
    },
  },
  methods: {
    addUser(user: User): void {
      (this.$refs.usersList as ListElement).unshift(user);
    },
  },
  components: {
    InviteUserBtn,
    UsersList,
  },
});
